<template>
  <DashboardChartWrapper
    title="Ventes par heure"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <Bar v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import DashboardChartWrapper from './DashboardChartWrapper.vue'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/charts/hourly-sales', dateParams)

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => `${d.hour}h`),
    datasets: [{
      label: 'Nb ventes',
      data: data.value.map(d => d.count),
      backgroundColor: '#3b82f6',
      borderRadius: 4
    }]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false }
  },
  scales: {
    y: { beginAtZero: true }
  }
}
</script>
